/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyInformationBankDetails
 */
export interface CompanyInformationBankDetails {
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    readonly companySettings?: string;
    /**
     * 
     * @type {Date}
     * @memberof CompanyInformationBankDetails
     */
    readonly dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CompanyInformationBankDetails
     */
    readonly dateUpdated?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    bankAccountName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    bankAccountNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    bankSortCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    bankName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    bankAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    bankPostcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    bankIban?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    bankRoutingCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    bankAccountHoldingBranch?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInformationBankDetails
     */
    bankBicSwiftCode?: string | null;
}

/**
 * Check if a given object implements the CompanyInformationBankDetails interface.
 */
export function instanceOfCompanyInformationBankDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CompanyInformationBankDetailsFromJSON(json: any): CompanyInformationBankDetails {
    return CompanyInformationBankDetailsFromJSONTyped(json, false);
}

export function CompanyInformationBankDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyInformationBankDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'companySettings': !exists(json, 'company_settings') ? undefined : json['company_settings'],
        'dateCreated': !exists(json, 'date_created') ? undefined : (new Date(json['date_created'])),
        'dateUpdated': !exists(json, 'date_updated') ? undefined : (new Date(json['date_updated'])),
        'bankAccountName': !exists(json, 'bank_account_name') ? undefined : json['bank_account_name'],
        'bankAccountNumber': !exists(json, 'bank_account_number') ? undefined : json['bank_account_number'],
        'bankSortCode': !exists(json, 'bank_sort_code') ? undefined : json['bank_sort_code'],
        'bankName': !exists(json, 'bank_name') ? undefined : json['bank_name'],
        'bankAddress': !exists(json, 'bank_address') ? undefined : json['bank_address'],
        'bankPostcode': !exists(json, 'bank_postcode') ? undefined : json['bank_postcode'],
        'bankIban': !exists(json, 'bank_iban') ? undefined : json['bank_iban'],
        'bankRoutingCode': !exists(json, 'bank_routing_code') ? undefined : json['bank_routing_code'],
        'bankAccountHoldingBranch': !exists(json, 'bank_account_holding_branch') ? undefined : json['bank_account_holding_branch'],
        'bankBicSwiftCode': !exists(json, 'bank_bic_swift_code') ? undefined : json['bank_bic_swift_code'],
    };
}

export function CompanyInformationBankDetailsToJSON(value?: CompanyInformationBankDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bank_account_name': value.bankAccountName,
        'bank_account_number': value.bankAccountNumber,
        'bank_sort_code': value.bankSortCode,
        'bank_name': value.bankName,
        'bank_address': value.bankAddress,
        'bank_postcode': value.bankPostcode,
        'bank_iban': value.bankIban,
        'bank_routing_code': value.bankRoutingCode,
        'bank_account_holding_branch': value.bankAccountHoldingBranch,
        'bank_bic_swift_code': value.bankBicSwiftCode,
    };
}

